import { render, staticRenderFns } from "./ModalUploadCallCenter.vue?vue&type=template&id=567a08da&"
import script from "./ModalUploadCallCenter.vue?vue&type=script&lang=js&"
export * from "./ModalUploadCallCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports